import loadable from 'react-loadable';
import {Loading} from '../common';

export const SplashPage = loadable({
    delay: 300,
    loader: () => import('./SplashPage'),
    loading: Loading
});


// WEBPACK FOOTER //
// ./src/components/splash/index.js